<template>
  <div class="cf-footer" id="kt_copyright_footer">
    <span class="cf-footer__text">
      Copyright &copy; {{ currentYear }} Total Biometric Solutions LLC. All rights reserved.
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  computed: {
    ...mapGetters(["layoutConfig"]),
    currentYear() {
      return new Date().getFullYear();
    },
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    },
  },
};
</script>

<style lang="scss" scoped>
.cf-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100vw;
  background: #2c7d76;
  padding: 12px 20px;
  text-align: center;
  z-index: 9999;

  &__text {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.88);
    font-family: 'Segoe UI', system-ui, sans-serif;
    letter-spacing: 0.01em;
  }
}
</style>
